export default __webpack_public_path__ + "static/media/bed-view.3462aad9.jpg";